module.exports = __webpack_public_path__ + "static/media/iservo.37e34530.svg";